import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav';

import heroMobileImage from '../../images/articles/wf-isf-perspectives-solar-projects_767x577.jpg';
import heroDesktopImage from '../../images/articles/wf-isf-perspectives-solar-projects_1164x584.jpg';

import bodyDesktopImage from '../../images/articles/wf-isf-perspective-city-of-refuge-desktop.jpg';
import bodyMobileImage from '../../images/articles/wf-isf-perspective-city-of-refuge-mobile.jpg';

import ModalOverlay from "../../components/ModalOverlay";

import { fireTag } from '../../libs/analytics.js';

import EVShareMobile from '../../images/articles/EV-share-mobile.png';
import EVRangeMobile from '../../images/articles/EV-range-mobile.png';

const Solar = ({
				handleEvent,
				modalOverlay,
				closeExitOverlay,
				addExitClickListeners,
			}) => {

	const [enableScrollGA, setEnableScrollGA] = useState(false);
	const [shouldBeInert, setShouldBeInert] = useState(false);
	const [gridVisible, setGridVisible] = useState(false);
	const heroOGImage = 'wf-isf-perspectives-solar-projects_ogimage.jpg';

	addExitClickListeners();

	const toggleInert = () => {
		setShouldBeInert(!shouldBeInert)
	}


	const toggleGrid = () => {
		const grid = document.getElementsByClassName('grid')[0];
		grid.style.display = (!gridVisible) ? 'none' : 'block';
		setGridVisible(!gridVisible)
	}

	const KonamiElement = () => {
		useKonami(toggleGrid, {
			code: [37, 39, 37, 39]
		});
		return <div className="grid" style={{display: gridVisible ? 'block' : 'none'}}/>;
	};

	const linkDisclosures = () => {
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];
				fireTag('A2',disclosureNumber);
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});

				window.setTimeout(() => {
					// console.log(' ======== ');
					// console.log(targetElement);
					targetElement.focus();
				}, 1000);

			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}


	useEffect(() => {

		// console.log(`To see grid overlay, type ↑ ↑ ↓ ↓ ← → ← → B A inside the browser window`);
		ScrollToTop(setEnableScrollGA)
		linkDisclosures();

	}, []); // empty array says only use this effect once

	let mastheadImage;
	let bodyImage;

	switch (true) {
		case (window.innerWidth < 768):
			mastheadImage = heroMobileImage;
			bodyImage = bodyMobileImage;
			break;
		case (window.innerWidth < 1440):
			mastheadImage = heroDesktopImage;
			bodyImage = bodyDesktopImage;
			break;
		case (window.innerWidth >= 1440):
			mastheadImage = heroDesktopImage;
			bodyImage = bodyDesktopImage;
			break;
	}
	// console.log(mastheadImage);
	// console.log(process.env.PUBLIC_URL);

	return (
		<>
			<Helmet>
				<title>The future of community-accessible solar projects </title>
				<meta
					name="description"
					content="Wells Fargo's donation supports the development of a financial model to help tax-exempt entities invest in community resilience. "
				/>
				<meta property="og:title" content="The future of community-accessible solar projects "/>
				<meta
					property="og:description"
					content="Wells Fargo's donation supports the development of a financial model to help tax-exempt entities invest in community resilience. "
				/>
				<meta property="og:image" content={`https://welcome.wf.com/impact/images/articles/${heroOGImage}`}/>
				<meta property="og:url" content={`https://welcome.wf.com/impact/sustainability/future-of-community-accessible-solar-projects/`}/>
				<meta property="twitter:title" content="The future of community-accessible solar projects"/>
				<meta
					property="twitter:description"
					content="Wells Fargo's donation supports the development of a financial model to help tax-exempt entities invest in community resilience."
				/>
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}
			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>
			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}

			<main className='flex-container article-4'>

				<div className="flex-row">
					{/*flex-col-md-8*/}
					<div className="flex-col-sm-12 headline">
						<h1 id="articles-main-h1" style={{marginBottom: 10}}>
							The future of community-accessible solar projects
						</h1>
						<h2 className="summary">
							Wells Fargo’s donation supports the development of a financial model to help tax-exempt entities invest in community resilience.
						</h2>
					</div>

				</div>

				<div className="flex-row full-width exception white-background">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt="A man in a hard hat shields his eyes from the sun as he examines a row of solar panels."/>
					</div>
				</div>

				<div className="flex-row">


					<div className="flex-col-md-12 flex-col-sm-12 text-center article-intro info-graphic">
						<div className="by-line">
							<p>By John Moon, <span>senior vice president, sustainability philanthropy leader at Wells Fargo</span></p>
						</div>
						<div className="article-info">
							<div>
								<p>December 21, 2023</p>
							</div>
							<div>
								<p>6-minute read</p>
							</div>
						</div>
						<p>A solar and battery storage installation for <a onClick={()=>fireTag('A1','city of refuge')} target="_blank" href="https://www.cityofrefugebaltimore.org/" rel="noreferrer" data-click-listener="true">City of Refuge</a>, a faith-based community organization in Baltimore, might have been financially unfeasible just a couple of years ago. As an organization with no tax liability, the nonprofit would likely have faced difficulty in receiving some financial benefits associated with federal tax credits for the project. However, the ambitious project is moving ahead due to a game-changing provision in the Inflation Reduction Act (IRA) called direct pay.
						</p>
						<p>
						The IRA is widely recognized as one of the largest climate and clean energy investment policies in the world, marrying tax credits and rebates with greenhouse gas reductions. The U.S. government <a onClick={()=>fireTag('A1','estimates')} target="_blank" href="https://www.dol.gov/general/inflation-reduction-act-tax-credit#:~:text=The%20Inflation%20Reduction%20Act%20(IRA,be%20delivered%20through%20tax%20incentives" rel="noreferrer" data-click-listener="true">estimates</a> that 70% of IRA funding will be delivered through tax incentives. For nonprofits, state and local governments, tribal entities, and low-income households without tax liability, the IRA’s direct pay provision provides direct access to benefits for eligible projects. Essentially, these tax-exempt entities can <a onClick={()=>fireTag('A1','receive')} target="_blank" href="https://www.irs.gov/payments/direct-pay" rel="noreferrer" data-click-listener="true">receive</a> funds in the amount of the tax credits. This opens the door to decarbonization opportunities that previously required nonprofits to collaborate with other entities to pass through and access tax credits using more complex legal arrangements. This approach diminished the value of the tax credits and sometimes the level of support available to a project.
						</p>
					</div>


				</div>


				<div className="flex-row">
					<div className="flex-col-md-12 flex-col-sm-12 text-center article-intro" style={{paddingTop: 0}}>
						<h2 className="subhead">Direct pay can help expand equity-focused opportunities</h2>
						<p>
							The direct pay provision can facilitate broader community access and enhance the associated benefits with greater monetary access to the IRA incentives, especially if so-called adders — additional incentives within the IRA, such as the 20% low-income community bonus credit for renewable projects in qualifying low-income communities — can be accessed.
						</p>
						<p>
							City of Refuge provides underserved residents in South Baltimore with access to food and other essential services to transition individuals and families out of crisis. It serves a predominantly low-income, ethnically diverse population through a holistic approach that offers health and wellness services, workforce development, and supportive affordable housing. The organization’s community members have increasingly faced impacts of climate change with hotter temperatures, flooding, and power outages.
						</p>
						<p>
							In August, <a onClick={()=>fireTag('A1','strong storms')} target="_blank" href="https://www.baltimoresun.com/2023/08/09/maryland-weather-thousands-without-power-tuesday-in-baltimore-region-this-storm-was-real/" rel="noreferrer" data-click-listener="true">strong storms</a> hit the Baltimore region — knocking down trees, utility poles, and power lines — affecting more than 89,000 utility customers. Some residents were <a onClick={()=>fireTag('A1','without power')} target="_blank" href="https://www.bge.com/News/Pages/Press%20Releases/August-7-2023-Storm-Update.aspx" rel="noreferrer" data-click-listener="true">without power</a> for more than a day. These events are not only costly but can cause unexpected financial and health burdens for those who rely on power-operated medical equipment and temperature-sensitive medications.
						</p>
						<p>
							To address some of these impacts, City of Refuge is working with <a onClick={()=>fireTag('A1','groundswell')} target="_blank" href="https://groundswell.org/" rel="noreferrer" data-click-listener="true">Groundswell</a>, a nonprofit that builds community solar and resilience projects, to be among the first nonprofits in Maryland to tap into the IRA’s direct pay incentives to develop a community resilience hub. This project is expected to include rooftop solar panels and battery storage to serve as an operational community gathering space during weather emergencies. When it’s not used as a resilience hub, the center plans to offer child care and job training — including a solar installation program. The direct pay feature allows needed financial support to make the solar and storage more financially feasible and serves as financial equity to enable ownership of the project to support asset building for the nonprofit.
						</p>
						<div className="flex-row article-image">
							<img alt={'A CGI rendering of a large modern building with solar panels in Baltimore'} src={bodyImage}/>
							<p className="image-caption">Project rendering for the planned City of Refuge resilience hub in Baltimore, MD.</p>
						</div>
						<p>
						Pastor Billy Humphrey, the executive director of City of Refuge, expects savings from the solar panels will help to expand the organization’s impact. "Not only are we increasing the capacity of our operational budget to continue to do good work and expand the work, we're also contributing to the larger environment," he said.
						</p>
					</div>
				</div>

				<div className="flex-row">
					<div className="flex-col-md-12 flex-col-sm-12 text-center article-intro" style={{paddingTop: 0}}>
						<h2 className="subhead">A financial model can help generate more solar projects</h2>
						<p>
							The Wells Fargo Foundation’s sustainability philanthropy team is supporting Groundswell's work to develop a financial model designed to leverage the direct pay provision with other forms of financing to increase the savings potential and serve as a model for replication. Upon completion, the City of Refuge resilience hub can serve as a real-world example that demonstrates the cost and savings so that similar transactions can be considered in other locations.
						</p>
						<p>
							"Direct pay is a game changer for community solar and resilience projects,” added Michelle Moore, CEO of Groundswell. “The vision we share is for more community-based organizations like City of Refuge to own their own power — as individual projects, as values-aligned portfolios, and as virtual community power plants generating the energy we need for a just, clean, and thriving future."
						</p>
						<p>
							This type of financial model can then help to create a ripple effect, inspiring other communities around the country to leverage private finance to adopt clean energy projects.
						</p>
					</div>
				</div>
				{/*<KonamiElement className="grid"/>*/}
			</main>

			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>
			{/* Adobe retargeting tag */
			}
			{
				/*
					REMOVE TAG
					<img alt="" src="https://rtd-tm.everesttech.net/upi/?sid=s6cvr4h2qH04B3WUwCOG&cs=1" style={{display: 'none'}}/>
				*/
			}

			{
				modalOverlay && modalOverlay.open && (
					<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
				)
			}
		</>
	);
};

export default withRouter(Solar);
